import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { removeProductFromList } from '../../../../features/SalesSlice/SalesSlice';
import { AiOutlineClose } from 'react-icons/ai';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiCreditCard, FiPackage } from 'react-icons/fi';
import './MobileDefaultSales.css';
import useFetchData from '../../../../hooks/useFetchData';
import { format, parseISO } from 'date-fns';

const AddSalesInvoice = ({ details, isInvoice, isCustomer }) => {
    const userAc = useSelector((state) => state.user.user);
    const { productList } = useSelector((state) => state.salesInvoice);
    const [dueAmount, setDueAmount] = useState();
    const [totalAmount, setTotalAmount] = useState();
    const [isPayment, setIsPayment] = useState(false);
    const [isDiscount, setIsDiscount] = useState(false);
    const [discount, setDiscount] = useState('');
    const [payment, setPayment] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const isMobileCheckout = location.pathname.startsWith('/mobile/');
    const { items } = useFetchData('https://servers.thakurgaonexpress.com/rupkotha/getsalesinvoice');
    const { items: sms } = useFetchData('https://servers.thakurgaonexpress.com/rupkotha/getsms')

    console.log(sms);

    const removeFromList = (product) => {
        dispatch(removeProductFromList(product));
    }

    let currentDate = new Date(details?.salesDate);
    // Get the current month and year as strings
    let monthName = currentDate.toLocaleString('default', { month: 'long' });
    let yearName = currentDate.toLocaleString('default', { year: 'numeric' });

    const total = productList.reduce((total, currentValue) => total + parseFloat(currentValue?.total), 0);

    const handleDiscount = (event) => {
        const discount = parseFloat(event?.target?.value);
        setDiscount(discount);
        // const grand = total - discount;
        // setTotalAmount(grand);
        setIsDiscount(true);
    }
    const handlePayment = (event) => {
        const payment = parseInt(event?.target?.value);
        setPayment(payment);
        // const dueAmount = totalAmount - payment;
        // setDueAmount(dueAmount);
        setIsPayment(true);
        setIsDiscount(true);
    }

    const totalRef = useRef('');
    const discountRef = useRef();
    const grandTotalRef = useRef();
    const paymentRef = useRef();
    const dueAmountRef = useRef();


    const handleSubmitSales = () => {
        const totalAmount = parseFloat(totalRef.current.innerText);
        const discount = parseFloat(discountRef.current.value);
        const grandTotal = parseFloat(grandTotalRef.current.value);
        const paymentdata = parseFloat(paymentRef.current.value);
        const payment = paymentdata ? parseFloat(paymentRef.current.value) : 0;

        const isAdvance = payment === 0 & grandTotal <= Math.abs(details.salesOpening) ? true : false;
        const isPaid = payment + Math.abs(details.salesOpening) >= grandTotal ? true : false;

        const dueData = parseFloat(dueAmountRef.current.value)
        const dueAmount = dueData ? parseFloat(dueAmountRef.current.value) : 0;
        const user = userAc?.email.split('@')[0];
        const month = monthName + " " + yearName;
        const paid = dueAmount === 0 ? true : isAdvance === true ? true : isPaid ? true : false;


        const data = { products: productList, ...details, totalAmount, discount, grandTotal, payment, user, dueAmount, paid, month }

        console.log(data);
        fetch('https://servers.thakurgaonexpress.com/rupkotha/sales', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(data),
        })
            .then(res => res.json())
            .then(data => {
                toast.success('Sales Added Successfull')
                navigate(isMobileCheckout ? '/mobile/managedefaultsales' : '/managedefaultsales')
                setTimeout(() => { window.location.reload(); }, 2000);
            })

        if (sms[0]?.smsAmount > 3 & dueAmount > 0) {
            const token = `92310756091678413369ac9dc34ff7599524a6ea84a77094beb1`;
            const number = details.salesPhone;
            const msg = `প্রিয় ${details.salesCustomer}, ${details.salesDate} তারিখে ${details.salesInvoice} নং মেমোতে আপনার নিকট বাকিতে বিক্রয় ${dueAmount} টাকা, আপনার নিকট সর্বমোট পাওনা ${details.salesOpening + dueAmount} টাকা, ধন্যবাদ জীবন ট্রেডার্স`;
            const message = encodeURI(msg)

            const url = `https://api.greenweb.com.bd/api.php?token=${token}&to=${number}&message=${message}`

            fetch(url)
                .then(res => res.json())
                .then(data => {
                    console.log(data);
                })

            fetch(`https://servers.thakurgaonexpress.com/rupkotha/getsms/${sms[0]?._id}`, {
                method: 'PUT',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ smsAmount: sms[0]?.smsAmount - 3 })
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data);
                })
        }

    }
    const checkoutTotal = isDiscount ? total - discount : total;
    const checkoutDue = checkoutTotal - payment;

    if (isMobileCheckout) {
        return <>
            <section className="mobile-sale-checkout__section mobile-default-invoice"><div className="mobile-sale-checkout__section-head"><h2><FiPackage />Cart</h2><small>{productList.length} item{productList.length === 1 ? '' : 's'}</small><span ref={totalRef} className="hidden">{total.toFixed(2)}</span></div><div className="mobile-sale-checkout__cart">{productList.length === 0 ? <div className="mobile-sale-checkout__empty">Search and choose a product to begin this sale.</div> : productList.map((product, index) => { const productName = product.name || product.productName || product.product_name || 'Selected product'; return <article className="mobile-sale-checkout__item" key={`${product.code}-${index}`}><div className="mobile-sale-checkout__item-top"><div><strong>{productName}</strong><small>{product.code || product.productCode || '—'} · Available stock {product.stock ?? '—'}</small></div><button type="button" className="mobile-sale-checkout__remove" onClick={() => removeFromList(product)} aria-label={`Remove ${productName}`}><AiOutlineClose /></button></div><div className="mobile-default-invoice__line"><div><small>Quantity</small><strong>{product.quantity}</strong></div><div><small>Rate</small><strong>{Number(product.rate || product.sell || 0).toFixed(2)}</strong></div><div><small>Line total</small><strong>{Number(product.total || 0).toFixed(2)}</strong></div></div></article>})}</div></section>
            <section className="mobile-sale-checkout__summary mobile-default-invoice__summary"><div className="mobile-sale-checkout__summary-top"><div><small>Grand total</small><strong>{checkoutTotal.toFixed(2)}</strong><input ref={grandTotalRef} className="hidden" value={checkoutTotal.toFixed(2)} readOnly /></div><span>{productList.length} cart item{productList.length === 1 ? '' : 's'}</span></div><div className="mobile-sale-checkout__adjustments"><div className="mobile-sale-checkout__field"><label>Discount</label><input ref={discountRef} onChange={handleDiscount} type="number" inputMode="decimal" placeholder="0.00" /></div><div className="mobile-sale-checkout__field"><label>Current total</label><input value={checkoutTotal.toFixed(2)} readOnly /></div></div><div className="mobile-sale-checkout__payment-row"><div className="mobile-sale-checkout__pay-card"><small><FiCreditCard />Cash payment</small><input ref={paymentRef} onChange={handlePayment} type="number" inputMode="decimal" placeholder="0.00" /></div><div className="mobile-sale-checkout__pay-card"><small>Due amount</small><input ref={dueAmountRef} value={checkoutDue.toFixed(2)} readOnly /></div></div><button disabled={!isInvoice || !userAc?.addSales || details?.duplicate || !isCustomer || productList.length === 0} onClick={handleSubmitSales} className="mobile-sale-checkout__submit">Complete sale · {checkoutTotal.toFixed(2)}</button></section>
        </>;
    }
    return (
        <div className='lg:grid lg:grid-cols-12 gap-2 h-screen'>
            <div className='overflow-auto lg:col-span-10 text-xs z-30 mb-4'>
                <div className=''>
                    <table class="table w-1/2 mx-auto">
                        <thead className='text-center'>
                            <tr>
                                <th className='bg-primary text-white normal-case'>SL#</th>
                                <th className='bg-primary text-white normal-case'>Product Code</th>
                                <th className='bg-primary text-white normal-case'>Product Name</th>
                                <th className='bg-primary text-white normal-case'>Quantity</th>
                                <th className='bg-primary text-white normal-case'>Rate</th>
                                <th className='bg-primary text-white normal-case'>Total</th>
                                <th className='bg-primary text-white normal-case'>Action</th>
                            </tr>
                        </thead>
                        <tbody className='text-center'>
                            {
                                productList?.map((product, index) => <tr className='hover'>
                                    <td className='h-8'>{index + 1}</td>
                                    <td className='h-8'>{product?.code}</td>
                                    <td className='text-xs'>{product?.name}</td>
                                    <td><input type="number" value={product?.quantity} placeholder="Type here" className="input text-xs input-bordered text-center h-8 w-20 max-w-lg" /></td>
                                    <td><input type="number" value={product?.rate} placeholder="Type here" className="input text-xs input-bordered text-center h-8 w-28 max-w-lg" /></td>
                                    <td><input type="number" value={product?.total} placeholder="Type here" className="input text-xs input-bordered text-center h-8 w-40 max-w-lg" /></td>
                                    <td> <button onClick={() => removeFromList(product)} className={`btn btn-sm btn-error cursor-pointer`}><AiOutlineClose /></button> </td>
                                </tr>)
                            }

                        </tbody>
                        <tfoot className='text-center h-2'>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Total</td>
                                <td ref={totalRef} className='text-md'>{total.toFixed(2)}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Discount</td>
                                <td> <input ref={discountRef} onChange={handleDiscount} type="number" placeholder="Type Discount" className="input input-bordered text-center text-xs w-48 h-8 mx-auto max-w-lg" /></td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
           <div className="overflow-auto lg:col-span-2 ml-20 lg:ml-0">
    <div
        style={{ height: '400px' }}
        className="bg-primary w-48 text-xs text-center flex flex-col items-center"
    >
        {/* Grand Total */}
        <div className="w-full mt-3">
            <label className="block text-white normal-case mb-2">
                Grand Total
            </label>

            <input
                ref={grandTotalRef}
                type="number"
                value={
                    isDiscount === true
                        ? (total - discount).toFixed(2)
                        : total.toFixed(2)
                }
                placeholder="Type here"
                className="input text-xs input-bordered text-center w-36 mx-auto"
            />
        </div>

        {/* Cash Payment */}
        <div className="w-full mt-4">
            <label className="block text-white normal-case mb-2">
                Cash Payment
            </label>

            <input
                ref={paymentRef}
                onChange={handlePayment}
                type="number"
                placeholder="Type Payment"
                className="input text-xs input-bordered text-center w-36 mx-auto"
            />
        </div>

        {/* Due Amount */}
        <div className="w-full mt-4">
            <label className="block text-white normal-case mb-2">
                Due Amount
            </label>

            <input
                ref={dueAmountRef}
                type="number"
                value={
                    isDiscount === false
                        ? total.toFixed(2)
                        : ((total - discount) - payment).toFixed(2)
                }
                placeholder="Type here"
                className="input text-xs input-bordered text-center w-36 mx-auto"
            />
        </div>

        {/* Button directly below Due Amount */}
        <button
            disabled={
                !isInvoice ||
                !userAc?.addSales ||
                details?.duplicate ||
                !isCustomer
            }
            onClick={handleSubmitSales}
            className="btn btn-sm mt-3 text-white"
        >
            Add Sales
        </button>
    </div>
</div>
        </div>
    );
};

export default AddSalesInvoice;

//finalAmount === false ? totalAmount : isDue === false ? grandAmount : dueAmount
